/** Shared resting-card treatment. Padding and layout belong to the caller. */
export const CARD_CLASS =
	"rounded-lg border border-border/70 bg-card shadow-sm ring-1 ring-border/30";
